module.exports = __webpack_public_path__ + "static/media/download.0e09bcfc.svg";